var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import jsQR from 'jsqr';
import Encoding from 'encoding-japanese';
import { useTranslation } from "../../../../hooks/useTranslation";
import { useInterval } from "../../../../hooks/useInterval";
import { CameraFlip } from "../../../../icons/index";
import { makeStyles, Typography } from "../../../../index";
import { getAnotherFacingMode } from "../utils/getAnotherFacingMode";
import { getMediaStreamConstraints } from "../utils/getMediaStreamConstraints";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        height: '100%',
        flex: 1,
        position: 'relative',
        overflow: 'hidden',
        background: theme.palette.dark.background.default,
    },
    rootCameraDisabled: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: theme.palette.light.background.default,
    },
    canvas: {
        display: 'none',
    },
    video: {
        position: 'absolute',
        height: '100%',
        left: 0,
        right: 0,
        margin: 'auto',
    },
    flipButton: {
        position: 'absolute',
        cursor: 'pointer',
        right: 0,
        top: 0,
    },
    flipIcon: {
        color: theme.palette.dark.text.primary,
    },
}); });
var initialCameraState = {
    facingMode: 'environment',
    flipEnabled: true,
    enabled: true,
};
export var QrCodeCamera = function (props) {
    var open = props.open, onQrCodeFind = props.onQrCodeFind, onCameraDisabled = props.onCameraDisabled;
    var _a = useState(initialCameraState), cameraState = _a[0], setCameraState = _a[1];
    var canvas = useRef(null);
    var video = useRef(null);
    var stopCapture = useCallback(function (videoElement) {
        if (videoElement == null)
            return;
        if (videoElement.srcObject instanceof MediaStream) {
            videoElement.srcObject.getTracks().forEach(function (track) { return track.stop(); });
            videoElement.srcObject = null;
        }
    }, []);
    var startCapture = useCallback(function (videoElement, abortSignal) { return __awaiter(void 0, void 0, void 0, function () {
        var constraints, stream, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (videoElement == null)
                        return [2 /*return*/];
                    stopCapture(videoElement); // 切り替え時など、既に動いているキャプチャを停止する。
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    constraints = getMediaStreamConstraints(cameraState.facingMode);
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia(constraints)];
                case 2:
                    stream = _a.sent();
                    videoElement.srcObject = stream;
                    return [4 /*yield*/, videoElement.play()];
                case 3:
                    _a.sent();
                    if (abortSignal.aborted) {
                        stopCapture(videoElement);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    if (e_1 instanceof OverconstrainedError && e_1.constraint === 'facingMode') {
                        // facingMode属性が無効の場合（MacBookなど）は'no-facing-mode'にして試す。
                        setCameraState(function (prev) { return (__assign(__assign({}, prev), { facingMode: 'no-facing-mode', flipEnabled: false })); });
                        return [2 /*return*/];
                    }
                    if (cameraState.flipEnabled) {
                        // 切り替えが有効な状態での失敗は、切り替えを無効にしてもう片方のfacingModeを試す。
                        setCameraState(function (prev) { return (__assign(__assign({}, prev), { facingMode: getAnotherFacingMode(prev.facingMode), flipEnabled: false })); });
                        return [2 /*return*/];
                    }
                    // 既に切り替えボタンが無効の場合は使えるカメラがないのでブロック
                    setCameraState(function (prev) { return (__assign(__assign({}, prev), { enabled: false })); });
                    onCameraDisabled();
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [stopCapture, cameraState, onCameraDisabled]);
    useEffect(function () {
        var abortController = new AbortController();
        var videoElement = video.current; // cleanup関数内ではvideo.currentがnullになるので参照先を控えておく
        if (open) {
            startCapture(videoElement, abortController.signal);
        }
        return function () {
            abortController.abort();
            stopCapture(videoElement);
        };
    }, [open, startCapture, stopCapture]);
    var handleClickFlipButton = useCallback(function () {
        setCameraState(function (prev) { return (__assign(__assign({}, prev), { facingMode: getAnotherFacingMode(prev.facingMode) })); });
    }, []);
    var readQrCode = useCallback(function () {
        if (canvas.current && video.current) {
            var context = canvas.current.getContext('2d');
            if (context) {
                canvas.current.width = video.current.clientWidth;
                canvas.current.height = video.current.clientHeight;
                context.drawImage(video.current, 0, 0, video.current.clientWidth, video.current.clientHeight);
                var imageData = context.getImageData(0, 0, video.current.clientWidth, video.current.clientHeight);
                var recognizedCode = jsQR(imageData.data, imageData.width, imageData.height);
                if (recognizedCode) {
                    var resultText = Encoding.convert(recognizedCode.binaryData, { to: 'UNICODE', type: 'string' });
                    if (resultText) {
                        onQrCodeFind(resultText);
                    }
                }
            }
        }
    }, [onQrCodeFind]);
    useInterval(readQrCode, 1000);
    var classes = useStyles();
    var t = useTranslation().t;
    if (!cameraState.enabled) {
        return (React.createElement("div", { className: classNames(classes.root, classes.rootCameraDisabled) },
            React.createElement(Typography, { variant: "body1" }, t('カメラがブロックされています'))));
    }
    return (React.createElement("div", { className: classes.root },
        React.createElement("video", { className: classes.video, ref: video, onContextMenu: function (e) { return e.preventDefault(); } }),
        React.createElement("canvas", { className: classes.canvas, ref: canvas }),
        cameraState.flipEnabled && (React.createElement("div", { className: classes.flipButton, onClick: handleClickFlipButton },
            React.createElement(CameraFlip, { className: classes.flipIcon })))));
};
